import { Icons } from "../../assets/svgs";
import { TOAST_TYPES } from "../../utils/constants";
import { toastify } from "../../utils/helpers";

import * as S from "./styled";

export const MessageWithCopyIcons = ({ message, type }) => {
  const caseIdMatch = message?.match(/Case ID:\s*(\d+)/);
  const accountNumberMatch = message?.match(/Account Number\s*(\d+)/);

  const caseId = caseIdMatch?.[1] || "";
  const accountNumber = accountNumberMatch?.[1] || "";

  const beforeCaseId = message?.split("Case ID:")[0] || "";
  const afterCaseId = message?.split(`Case ID: ${caseId}`)[1] || "";

  const [beforeAccount, afterAccount] = afterCaseId.split(`Account Number ${accountNumber}`);

  return (
    <S.Message>
      {beforeCaseId}
      Case ID: {caseId}{" "}
      <Icons.CopyIcon
        className="copy"
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          navigator.clipboard.writeText(caseId);
          toastify(TOAST_TYPES.success, "Case ID Copied!", "", 1500, "top-left");
        }}
      />
      {beforeAccount}
      {type === "2" &&
      <>
      Account Number {accountNumber}{" "}
      <Icons.CopyIcon
        className="copy"
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          navigator.clipboard.writeText(accountNumber);
          toastify(TOAST_TYPES.success, "Account Number Copied!", "", 1500, "top-left");
        }}
      />
      </>
}
      {afterAccount}
    </S.Message>
  );
};
